import { useTranslation } from "react-i18next";

import { Button } from "@/components/ui/v2/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/v2/dialog";

interface UnsavedChangesDialogProps {
  open: boolean;
  onStay: () => void;
  onLeave: () => void;
}

/**
 * Global confirmation dialog shown when user tries to close a form with unsaved changes
 * Provides a consistent UX across the application for handling unsaved data
 */
export function UnsavedChangesDialog({ open, onStay, onLeave }: UnsavedChangesDialogProps) {
  const { t } = useTranslation();

  return (
    <Dialog open={open}>
      <DialogContent 
        className="sm:max-w-[600px] w-full"
        showCloseButton={false}
        onInteractOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle>{t("prompts.unsavedChanges.title")}</DialogTitle>
          <DialogDescription>
            {t("prompts.unsavedChanges.description")}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex flex-col-reverse sm:flex-row sm:justify-between gap-2">
          <Button
            variant="outline"
            onClick={onStay}
          >
            {t("prompts.unsavedChanges.stay")}
          </Button>
          <Button
            variant="destructive"
            onClick={onLeave}
          >
            {t("prompts.unsavedChanges.leave")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
